import { KORDARO_LOGO } from '../kordaroBrand.js';

type Variant = 'primary' | 'bordeaux' | 'ivory';

const LOGO_RATIO = 1148.78 / 205;
const MARK_RATIO = 277 / 245;

/**
 * Het vaste Kordaro-logo (SVG uit het huisstijlpakket). Nooit hertekenen of als tekst zetten.
 * Horizontaal logo minimaal 140 CSS-px breed; los teken minimaal 24 px.
 * `decorative` = herhaling naast zichtbare tekst → lege alt.
 */
export function KordaroLogo({ variant = 'primary', width = 140, decorative = false, className }: {
  variant?: Variant;
  width?: number;
  decorative?: boolean;
  className?: string;
}) {
  const w = Math.max(140, width);
  return (
    <img
      src={KORDARO_LOGO[variant]}
      alt={decorative ? '' : 'Kordaro'}
      width={w}
      height={Math.round(w / LOGO_RATIO)}
      className={className}
    />
  );
}

export function KordaroMark({ variant = 'primary', height = 24, decorative = false, className }: {
  variant?: 'primary' | 'ivory';
  height?: number;
  decorative?: boolean;
  className?: string;
}) {
  const h = Math.max(24, height);
  return (
    <img
      src={variant === 'ivory' ? KORDARO_LOGO.markIvory : KORDARO_LOGO.markPrimary}
      alt={decorative ? '' : 'Kordaro'}
      width={Math.round(h * MARK_RATIO)}
      height={h}
      className={className}
    />
  );
}
